import React from "react";

const BestInClassMarketplace = () => {
  return (
    <>
      {/* Large Screens */}
      <div className="w-full h-fit bg-whiteColor hidden lg:flex justify-between items-center mt-[3%]">
        <div className="w-[51%] h-fit flex flex-col pr-10">
          <span className="font-medium text-[1.82vw] text-textPrimaryColor mb-[2%]">
            India’s Best Labs Bazaar
          </span>
          <p className="font-normal text-[1vw] text-textSecondaryColor">
            Welcome to Fine Labs – India’s best lab bazaar, where
            health meets
          </p>
          <p className="font-normal text-[1vw] text-textSecondaryColor">
            convenience.
          </p>
          <p className="font-normal text-[1vw] text-textSecondaryColor">
          At Fine Labs, we are revolutionizing the way you access diagnostic services by partnering with India’s top trusted laboratories, including Agilus Diagnostics, Pathkind Labs, Redcliffe Labs, Metropolis Healthcare and more. Our mission is simple: to provide affordable, accurate, and timely health checkups with premium experience you deserve.
          </p>
          {/* <p className="font-normal text-[1vw] text-textSecondaryColor">
            you deserve.
          </p> */}
        </div>
        <img src="/assets/man-with-laptop.svg" alt="man-with-laptop" />
      </div>

      {/* Small Screens */}
      <div className="w-full h-fit bg-whiteColor lg:hidden">
        <div className="w-full h-fit flex flex-col mb-[2%]">
          <span className="font-semibold text-[5vw] text-textPrimaryColor mb-[2%]">
            India’s Best In-Class Labs Test Marketplace
          </span>
          <p className="font-normal text-[4vw] text-textSecondaryColor">
            Welcome to Fine Labs – India’s best lab test marketplace, where
            health meets convenience.
          </p>
          <p className="font-normal text-[4vw] text-textSecondaryColor">
            At Fine Labs, we are revolutionizing the way you access diagnostic
            services by partnering with India’s top trusted laboratories,
            including Pathkind Labs, Redcliffe Labs, Agilus Diagnostics and
            more. Our mission is simple: to provide affordable, accurate, and
            timely health checkups with premium experience you deserve.
          </p>
        </div>
        <img src="/assets/man-with-laptop.svg" alt="man-with-laptop" />
      </div>
    </>
  );
};

export default BestInClassMarketplace;
